const ProductType = {
  NORMAL: 'normal',
  WEIGHT: 'weight',
  LENGTH: 'length'
};

Object.freeze(ProductType);

export default ProductType;
